import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GeneralesProspecto } from '../models/generales-prospecto';

@Injectable({
  providedIn: 'root'
})
export class GeneralesProspectoService {

  private generalesSub = new BehaviorSubject<GeneralesProspecto>({ nombre: '', edad: '', genero: '', habito: '' });

  /**
   * Envia el ultimo valor al stream del observable.
   * @param prospecto a setear.
   */
  public setGeneralesProspecto(prospecto: GeneralesProspecto): void {
    this.generalesSub.next(prospecto);
  }

  /**
   * Obtenemos el observable de los generales del prospecto.
   */
  public getGeneralesProspecto(): Observable<GeneralesProspecto> {
    return this.generalesSub.asObservable();
  }
}
